$(function() {
  $('select.select2').select2({ theme: 'bootstrap' })
  $('.popup').tooltip()
})
